import { useEffect, useState } from "react";

interface DeferredRenderProps {
  children: React.ReactNode;
  delay?: number;
}

export default function DeferredRender({
  children,
  delay = 0,
}: DeferredRenderProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMounted(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!mounted) return null;

  return <>{children}</>;
}